import React, { useLayoutEffect, useRef } from 'react';

import PDF417 from 'pdf417-generator';
import styled from 'styled-components';

export interface IBarcode {
  value: string;
  className?: string;
}

const BarcodeCanvas = styled.canvas`
  width: 100%;
`;

const CanvasContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 250px;
  background-color: ${Styles.color.white};
  border-radius: 4px;
  padding: 7px;
`;

const Barcode: React.FC<IBarcode> = ({ value, className }) => {
  const canvas = useRef(null);

  useLayoutEffect(() => {
    if (canvas.current) {
      PDF417.draw(value, canvas.current, 3.5);
    }
  }, [canvas, value]);

  return (
    <CanvasContainer>
      <BarcodeCanvas className={className} ref={canvas} />
    </CanvasContainer>
  );
};

export default Barcode;
